export const SCHEMA_PLUG_PROGRAM = [
  {
    table_id: 'plug_output_plug_program',
    col_id: 'plug_id',
    col_name: 'Plug ID #',
    col_desc: 'Plug ID #',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'plug_name',
    col_name: 'Plug Name',
    col_desc: 'Plug Name',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'plug_num',
    col_name: 'Plug #',
    col_desc: 'Plug number (top-down order)',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'design_type',
    col_name: 'Design Type',
    col_desc: 'How the plug was produced: Manual, Regulation or Recommendation',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'plugging_method',
    col_name: 'Plugging Method',
    col_desc: 'Balanced Plug, Dump Bailer, Squeeze or Bridge Plug',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'plug_bot_depth',
    col_name: 'Plug Bottom Depth',
    col_desc: 'Bottom depth of the plug',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'packer_depth',
    col_name: 'Retainer Depth',
    col_desc: 'Squeeze only: depth of the cement retainer the cement is pumped through (default 50 ft above the perforation)',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'perf_casings',
    col_name: 'Perforated casing(s)',
    col_desc: 'Squeeze only: casing strings the perforation opens',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'squeeze_annulus',
    col_name: 'Squeeze Annulus',
    col_desc: 'Squeeze only: Open (returns up the annulus behind the casing) or Closed (fluids forced into the formation)',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'net_pressure',
    col_name: 'Net Pressure',
    col_desc: 'Squeeze with a closed annulus only: pressure above the fracture pressure for the fluid to move inside the fracture',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'annulus_surface_pressure',
    col_name: 'Annulus Surface Pressure',
    col_desc:
      'Squeeze only: pressure held on the annulus behind the casing at the wellhead (0 = annulus valve fully open, >0 = choked back)',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'perf_hole_diameter',
    col_name: 'Perforation Hole Diameter',
    col_desc: 'Squeeze only: diameter of one perforation hole (orifice pressure drop)',
    col_unit: 'in',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 3
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'perf_count',
    col_name: 'Number of Perforations',
    col_desc: 'Squeeze only: number of perforation holes',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'pipe_OD',
    col_name: 'Pipe OD',
    col_desc: 'Work string outer diameter',
    col_unit: 'in',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 3
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'pipe_ID',
    col_name: 'Pipe ID',
    col_desc: 'Work string inner diameter',
    col_unit: 'in',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 3
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'stinger_OD',
    col_name: 'Stinger OD',
    col_desc: 'Stinger outer diameter',
    col_unit: 'in',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 3
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'stinger_ID',
    col_name: 'Stinger ID',
    col_desc: 'Stinger inner diameter',
    col_unit: 'in',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 3
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'stinger_length',
    col_name: 'Stinger Length',
    col_desc: 'Stinger length',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'spacer_q',
    col_name: 'Spacer Rate',
    col_desc: 'Spacer pump rate',
    col_unit: 'bpm',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'spacer_volume',
    col_name: 'Spacer Volume',
    col_desc: 'Spacer volume',
    col_unit: 'bbl',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'spacer_height',
    col_name: 'Spacer Height',
    col_desc: 'Spacer column height',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'spacer_top',
    col_name: 'Spacer Top',
    col_desc: 'Top of spacer',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'spacer_duration',
    col_name: 'Spacer Duration',
    col_desc: 'Spacer pumping time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'spacer_den',
    col_name: 'Spacer Density',
    col_desc: 'Spacer density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'cement_q',
    col_name: 'Cement Rate',
    col_desc: 'Cement pump rate',
    col_unit: 'bpm',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'cement_volume',
    col_name: 'Cement Volume',
    col_desc: 'Cement slurry volume',
    col_unit: 'bbl',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'cement_height',
    col_name: 'Cement Height',
    col_desc: 'Cement column height',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'cement_top',
    col_name: 'Cement Top',
    col_desc: 'Top of cement',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'cement_duration',
    col_name: 'Cement Duration',
    col_desc: 'Cement pumping time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'cement_den',
    col_name: 'Cement Density',
    col_desc: 'Cement slurry density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'displacement_volume',
    col_name: 'Displacement Volume',
    col_desc: 'Displacement volume',
    col_unit: 'bbl',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'displacement_q',
    col_name: 'Displacement Rate',
    col_desc: 'Displacement pump rate',
    col_unit: 'bpm',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_plug_program',
    col_id: 'displacement_den',
    col_name: 'Displacement Density',
    col_desc: 'Displacement fluid density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  }
];

export const SCHEMA_RECOMMEND = [
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'plug_num',
    col_name: 'Plug #',
    col_desc: 'Recommended plug number (top-down order)',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'plug_name',
    col_name: 'Plug Name',
    col_desc: 'Recommended plug name',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'design_type',
    col_name: 'Design Type',
    col_desc: 'How the plug was produced: Manual, Regulation or Recommendation',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'depth',
    col_name: 'Design Depth',
    col_desc: 'Depth the regulation anchors this plug to (casing shoe, zone top, ...)',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'plug_type',
    col_name: 'Plug Type',
    col_desc: 'Regulatory plug category (Top plug, Surface plug, CIBP, ...)',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'plugging_method',
    col_name: 'Plugging Method',
    col_desc: 'Balanced Plug, Squeeze or Bridge Plug',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'top_depth',
    col_name: 'Top of Plug',
    col_desc: 'Top depth of the recommended cement plug',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'bottom_depth',
    col_name: 'Bottom of Plug',
    col_desc: 'Bottom depth of the recommended cement plug',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'sk_cement',
    col_name: 'Dry Cement Volume',
    col_desc: 'Sacks of dry cement required',
    col_unit: 'sk',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'gal_water',
    col_name: 'Mixing Water Volume',
    col_desc: 'Mixing water required',
    col_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'den_cement',
    col_name: 'Cement Density',
    col_desc: 'Cement slurry density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'cement_vol_bbl',
    col_name: 'Volume of Cement',
    col_desc: 'Cement slurry volume',
    col_unit: 'bbl',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'reference_code',
    col_name: 'Regulation Item',
    col_desc: 'Regulation requiring this plug',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'reference',
    col_name: 'Regulation Reference',
    col_desc: 'Why the plug is placed here, with the regulation citations',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_recommend_tbl',
    col_id: 'full_reference',
    col_name: 'Full Regulation Text',
    col_desc: 'Verbatim regulation text behind this plug (long; show on hover)',
    col_unit: '-',
    ui_editable: false,
    ui_show: false,
    data_type: 'str',
    decimal: 0
  }
];

export default SCHEMA_PLUG_PROGRAM;
